import { useEffect, useRef, useState } from "react";
import GenerateXml from "./GenerateXML";
import { X, Copy, Check } from "lucide-react";
import api from "../../api/axios";

export default function VastDropdown({ c }) {
    const [open, setOpen] = useState(false);
    const [copyVastURLModal, setCopyVastURLModal] = useState(null);
    const [editVastModal, setEditVastModal] = useState(false);
    const [copied, setCopied] = useState(false);

    const [loading, setLoading] = useState(false);

    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleCopy = async () => {
        try {
            setLoading(true);
            const response = await api.get(`/creative/generate-xml/${c.id}`);
            console.log(response.data.data, "VAST URL");
            setLoading(false);
            if (response && response.data && response.data.data) {
                const sampleVast = response.data.data;
                setCopyVastURLModal({ creative: c, url: sampleVast });
                setCopied(false);
                setOpen(false);
            }

        } catch (error) {
            setLoading(false);
        }
    };

    const handleEdit = () => {
        setEditVastModal(true);
        setOpen(false);
    };

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = c.vastUrl;
        link.download = "vast.xml";
        link.click();
        setOpen(false);
    };

    const handleCopyInsidePopup = () => {
        if (copyVastURLModal) {
            navigator.clipboard.writeText(copyVastURLModal.url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
        }
    };

    return (
        <div className="w-full relative inline-block text-center" ref={dropdownRef}>
            {/* <button
                type="button"
                onClick={handleCopy}
                disabled={loading}
                className={`mx-auto creative-card-btn creative-card-btn-vast flex items-center justify-center gap-2 ${loading ? "opacity-70 cursor-not-allowed" : ""
                    }`}
            >
                {loading && (
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}

                {loading ? "Copying..." : "Copy Vast URL"}
            </button> */}

            <button
                type="button"
                onClick={handleCopy}
                disabled={loading}
                className={`flex-1 flex items-center justify-center gap-2  w-full py-2.5 rounded-xl text-white font-medium text-sm transition-all duration-200 shadow-sm bg-black/80 `}
            >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
                <span>  {loading ? "Copying..." : "Copy Vast URL"}</span>
            </button>

            {/* Dropdown menu */}
            {open && (
                <div className="absolute right-0 bottom-10 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                    <button
                        onClick={handleCopy}
                        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                    >
                        Copy Vast URL
                    </button>
                    <button
                        onClick={handleEdit}
                        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                    >
                        Edit Vast Tag
                    </button>
                    <button
                        onClick={handleDownload}
                        className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                    >
                        Download Vast
                    </button>
                </div>
            )}

            {/* Copy VAST URL Modal */}
            {copyVastURLModal && (
                <div
                    className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[1111] p-4"
                    onClick={() => setCopyVastURLModal(null)}
                >
                    <div
                        className="relative bg-white w-full max-w-md rounded-2xl shadow-2xl p-6 animate-in fade-in zoom-in-95 duration-200"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setCopyVastURLModal(null)}
                            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition"
                        >
                            <X size={18} />
                        </button>

                        {/* Header */}
                        <h3 className="text-xl font-semibold text-gray-800 mb-1">
                            VAST Tag URL
                        </h3>
                        <p className="text-sm text-gray-500 mb-5 truncate">
                            {copyVastURLModal.creative.title}
                        </p>

                        {/* Input + Copy */}
                        <div className="flex items-center bg-gray-50 border border-gray-200 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-blue-500 transition">
                            <input
                                type="text"
                                readOnly
                                value={copyVastURLModal.url}
                                className="flex-1 px-4 py-3 bg-transparent text-gray-700 text-sm outline-none"
                            />

                            <button
                                onClick={handleCopyInsidePopup}
                                className={`px-4 py-3 flex items-center gap-2 transition font-medium ${copied
                                    ? "bg-green-500 text-white"
                                    : "bg-blue-600 hover:bg-blue-700 text-white"
                                    }`}
                            >
                                {copied ? <Check size={16} /> : <Copy size={16} />}
                                {copied ? "Copied" : "Copy"}
                            </button>
                        </div>

                        {/* Footer */}
                        <div className="flex justify-end mt-6">
                            <button
                                onClick={() => setCopyVastURLModal(null)}
                                className="px-5 py-2.5 text-sm font-medium bg-gray-100 hover:bg-gray-200 rounded-xl transition"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit VAST Modal */}
            {editVastModal && (
                <div
                    className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 p-4"
                    onClick={() => setEditVastModal(false)}
                >
                    <div
                        className="bg-white w-full max-w-6xl max-h-[90vh] rounded-xl shadow-xl flex flex-col"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header */}
                        <div className="flex justify-between items-center p-4 border-b">
                            <h2 className="text-lg font-semibold">Edit VAST Tag</h2>
                            <button
                                onClick={() => setEditVastModal(false)}
                                className="text-gray-500 hover:text-gray-700 text-xl"
                            >
                                ✕
                            </button>
                        </div>

                        {/* Scrollable Content */}
                        <div className="flex-1 overflow-y-auto p-4">
                            <GenerateXml />
                        </div>

                        {/* Footer */}
                        <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
                            <button
                                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                                onClick={() => setEditVastModal(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="px-4 cursor-pointer py-2 bg-gradient-to-r from-slate-800 to-slate-700 text-white rounded-lg font-medium hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 flex items-center gap-2"
                            >
                                Download XML
                            </button>
                            <button
                                className="px-4 cursor-pointer py-2 bg-gradient-to-r from-slate-800 to-slate-700 text-white rounded-lg font-medium hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 flex items-center gap-2"
                            >
                                Update XML
                            </button>
                        </div>
                    </div>
                </div>

            )}
        </div>
    );
}
